<template>
  <div class="container-imeisucesso">
    <b id="MODAL_SUCESSO">
      <div class="container-sucesso">
        <div class="container-titulo">
          <img src="@/assets/svg/icon-celular-green-success.svg"/>
          <div class="imei-registrado">
            <p class="label-sucesso">IMEI<br>registrado <br>com sucesso</p>
          </div>
        </div>
      </div>
      <div class="container-sucesso" v-if="myCiclicButton" >
        <b-button :href="myCiclicButton" variant="success" class="myciclic-button rounded-pill">
          VOLTAR
        </b-button>
      </div>
    </b>
  </div>
</template>

<script>
  import './ImeiSucesso.css'
  export default {
    name: 'modalSucesso',
    data: () => ({
      myCiclicButton: ''
    }),
    created () {
      this.myCiclicButton = this.$route.query['my-ciclic-button']

      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'cadastro-dispositivo',
        acao: 'IMEI',
        rotulo: 'sucesso'
      })
    }
  }
</script>

<style lang="scss">

#MODAL_SUCESSO {
  .myciclic-button {
    margin-top: 10px;
    padding: 10px 10%;
    width: 100%;
  }
}

</style>
